// extracted by mini-css-extract-plugin
export default {"breadcrumb":"styles_breadcrumb__fh256","active":"styles_active__ybR3Q"};